module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c("Default", {
    tag: "div",
    staticClass: "car-item-large",
    attrs: {
      "data": _vm.data,
      "v-lazy": _vm.vLazy,
      "width": 280
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7ae6b4f1!./~/vue-loader/lib/selector.js?type=template&index=0!./~/@souche-f2e/wangzhan-dependencies-car-item/vue/Large.vue
// module id = 108
// module chunks = 2 3 4 5